/**
 * 토큰 관리를 중앙화하는 클래스
 * 모든 토큰 관련 로직을 여기서 처리
 * 주기적 토큰 갱신 및 자동 관리 포함
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DEFAULT_STORAGE_KEYS, resolveStorageKeys } from './storage-keys';
import { handleRefreshTokenFlow } from './utils/refresh';
import { API_BASE_URLS } from '@edusense/shared-constants';
export var TokenManager = /*#__PURE__*/ function() {
    "use strict";
    function TokenManager() {
        _class_call_check(this, TokenManager);
        _define_property(this, "currentToken", null);
        _define_property(this, "currentRefreshToken", null);
        _define_property(this, "currentTokenType", 'Bearer');
        _define_property(this, "currentExpiresAt", null);
        _define_property(this, "listeners", []);
        _define_property(this, "tokenSetCallback", null);
        // 주기적 갱신 관련 속성
        _define_property(this, "refreshTimer", null);
        // 중요: authServerUrl은 항상 auth.ugot.uk를 사용해야 함
        _define_property(this, "authServerUrl", API_BASE_URLS.AUTH_SERVER) // 'https://auth.ugot.uk'
        ;
        _define_property(this, "isRefreshing", false);
        _define_property(this, "pendingRefreshPromise", null);
        _define_property(this, "storageKeys", DEFAULT_STORAGE_KEYS);
    }
    _create_class(TokenManager, [
        {
            key: "configureStorage",
            value: function configureStorage(storage) {
                this.storageKeys = resolveStorageKeys(storage);
                if (typeof localStorage === 'undefined') {
                    return;
                }
                this.currentToken = localStorage.getItem(this.storageKeys.tokenKey);
                this.currentRefreshToken = localStorage.getItem(this.storageKeys.refreshTokenKey);
                this.currentTokenType = localStorage.getItem(this.storageKeys.tokenTypeKey) || 'Bearer';
                var expiresAt = localStorage.getItem(this.storageKeys.tokenExpiresAtKey);
                this.currentExpiresAt = expiresAt ? parseInt(expiresAt, 10) : null;
            }
        },
        {
            /**
   * 외부 API 토큰 설정 콜백 등록
   */ key: "setTokenSetCallback",
            value: function setTokenSetCallback(callback) {
                this.tokenSetCallback = callback;
                // 기존 토큰이 있으면 즉시 호출
                if (this.currentToken) {
                    callback(this.currentToken);
                }
            }
        },
        {
            /**
   * 토큰 설정 (동기적으로 처리)
   */ key: "setToken",
            value: function setToken(token) {
                var tokenType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Bearer';
                console.log('[TokenManager] Setting token:', token ? '<token exists>' : 'null');
                var previousToken = this.currentToken;
                this.currentToken = token;
                this.currentTokenType = tokenType || 'Bearer';
                if (token) {
                    localStorage.setItem(this.storageKeys.tokenKey, token);
                    if (tokenType) {
                        localStorage.setItem(this.storageKeys.tokenTypeKey, tokenType);
                    }
                } else {
                    localStorage.removeItem(this.storageKeys.tokenKey);
                    localStorage.removeItem(this.storageKeys.tokenTypeKey);
                }
                // Clean up legacy token keys to avoid drift
                localStorage.removeItem('auth_access_token');
                localStorage.removeItem('accessToken');
                // 외부 API 서비스에 토큰 설정
                if (this.tokenSetCallback) {
                    this.tokenSetCallback(token, tokenType);
                }
                // 토큰이 변경된 경우에만 리스너에게 알림
                if (previousToken !== token) {
                    this.notifyListeners(token);
                }
            }
        },
        {
            /**
   * 리프레시 토큰 설정
   */ key: "setRefreshToken",
            value: function setRefreshToken(refreshToken) {
                console.log('[TokenManager] Setting refresh token:', refreshToken ? '<refresh token exists>' : 'null');
                this.currentRefreshToken = refreshToken;
                if (refreshToken) {
                    localStorage.setItem(this.storageKeys.refreshTokenKey, refreshToken);
                } else {
                    localStorage.removeItem(this.storageKeys.refreshTokenKey);
                }
            }
        },
        {
            /**
   * 현재 토큰 반환 (Lazy Loading)
   * E2E 테스트 호환성: 항상 localStorage를 먼저 확인하여 최신 값 반환
   */ key: "getToken",
            value: function getToken() {
                // ✅ Lazy Loading: 항상 localStorage를 먼저 확인
                // Playwright storageState가 로드된 후에도 정상 작동
                if (typeof localStorage !== 'undefined') {
                    var storedToken = localStorage.getItem(this.storageKeys.tokenKey);
                    // 🔍 디버깅: localStorage 값 확인
                    console.log('[TokenManager.getToken] 🔍', {
                        storedToken: storedToken ? "exists (".concat(storedToken.length, " chars)") : 'null',
                        cachedToken: this.currentToken ? "exists (".concat(this.currentToken.length, " chars)") : 'null',
                        needsSync: storedToken !== this.currentToken
                    });
                    // 캐시와 localStorage가 다르면 동기화
                    if (storedToken !== this.currentToken) {
                        this.currentToken = storedToken;
                        if (storedToken) {
                            console.log('[TokenManager] ✅ Token synced from localStorage');
                        }
                    }
                }
                return this.currentToken;
            }
        },
        {
            /**
   * 현재 리프레시 토큰 반환 (Lazy Loading)
   */ key: "getRefreshToken",
            value: function getRefreshToken() {
                // ✅ Lazy Loading: localStorage에서 최신 값 읽기
                if (typeof localStorage !== 'undefined') {
                    var storedRefreshToken = localStorage.getItem(this.storageKeys.refreshTokenKey);
                    if (storedRefreshToken !== this.currentRefreshToken) {
                        this.currentRefreshToken = storedRefreshToken;
                    }
                }
                return this.currentRefreshToken;
            }
        },
        {
            /**
   * 현재 토큰 타입 반환 (Lazy Loading)
   */ key: "getTokenType",
            value: function getTokenType() {
                // ✅ Lazy Loading: localStorage에서 최신 값 읽기
                if (typeof localStorage !== 'undefined') {
                    var storedTokenType = localStorage.getItem(this.storageKeys.tokenTypeKey);
                    if (storedTokenType && storedTokenType !== this.currentTokenType) {
                        this.currentTokenType = storedTokenType;
                    }
                }
                return this.currentTokenType;
            }
        },
        {
            /**
   * 토큰 타입 설정
   */ key: "setTokenType",
            value: function setTokenType(tokenType) {
                this.currentTokenType = tokenType;
                localStorage.setItem(this.storageKeys.tokenTypeKey, tokenType);
            }
        },
        {
            /**
   * 토큰 만료 시간 설정 (expiresIn: 초 단위)
   */ key: "setExpiresIn",
            value: function setExpiresIn(expiresIn) {
                // 현재 시간 + expiresIn 초로 만료 시간 계산
                this.currentExpiresAt = Date.now() + expiresIn * 1000;
                localStorage.setItem(this.storageKeys.tokenExpiresAtKey, this.currentExpiresAt.toString());
            }
        },
        {
            /**
   * 토큰 만료 여부 확인 (Lazy Loading)
   */ key: "isTokenExpired",
            value: function isTokenExpired() {
                // ✅ Lazy Loading: localStorage에서 만료 시간 읽기
                if (typeof localStorage !== 'undefined') {
                    var expiresAtStr = localStorage.getItem(this.storageKeys.tokenExpiresAtKey);
                    if (expiresAtStr) {
                        this.currentExpiresAt = parseInt(expiresAtStr, 10);
                    }
                }
                if (!this.currentExpiresAt) {
                    return false; // 만료 시간이 없으면 만료되지 않은 것으로 가정
                }
                return Date.now() >= this.currentExpiresAt;
            }
        },
        {
            /**
   * 토큰 존재 여부 확인 (Lazy Loading)
   */ key: "hasToken",
            value: function hasToken() {
                // ✅ getToken()을 호출하여 최신 localStorage 값 확인
                return !!this.getToken();
            }
        },
        {
            /**
   * 저장된 사용자 정보를 반환 (없으면 null)
   */ key: "getUser",
            value: function getUser() {
                if (typeof localStorage === 'undefined') {
                    return null;
                }
                var storedUserJson = localStorage.getItem(this.storageKeys.userKey);
                if (!storedUserJson) {
                    return null;
                }
                try {
                    return JSON.parse(storedUserJson);
                } catch (error) {
                    console.warn('[TokenManager] Failed to parse stored user JSON:', error);
                    return null;
                }
            }
        },
        {
            /**
   * 사용자 ID를 반환 (여러 필드 중 존재하는 값을 탐색)
   */ key: "getUserId",
            value: function getUserId() {
                var _user_profile, _user_profile1;
                var user = this.getUser();
                if (!user) {
                    return null;
                }
                var candidates = [
                    user.id,
                    user.userId,
                    user.userID,
                    user.uid,
                    user.sub,
                    user === null || user === void 0 ? void 0 : (_user_profile = user.profile) === null || _user_profile === void 0 ? void 0 : _user_profile.id,
                    user === null || user === void 0 ? void 0 : (_user_profile1 = user.profile) === null || _user_profile1 === void 0 ? void 0 : _user_profile1.userId
                ].filter(Boolean);
                if (candidates.length > 0) {
                    return String(candidates[0]);
                }
                return null;
            }
        },
        {
            /**
   * 사용자 표시 이름 반환 (없으면 null)
   */ key: "getUserDisplayName",
            value: function getUserDisplayName() {
                var _user_profile, _user_profile1;
                var user = this.getUser();
                if (!user) {
                    return null;
                }
                var candidates = [
                    user.displayName,
                    user.name,
                    user.fullName,
                    user.username,
                    user.userName,
                    user === null || user === void 0 ? void 0 : (_user_profile = user.profile) === null || _user_profile === void 0 ? void 0 : _user_profile.displayName,
                    user === null || user === void 0 ? void 0 : (_user_profile1 = user.profile) === null || _user_profile1 === void 0 ? void 0 : _user_profile1.name
                ].filter(function(value) {
                    return typeof value === 'string' && value.trim().length > 0;
                });
                if (candidates.length > 0) {
                    return String(candidates[0]);
                }
                var userId = this.getUserId();
                return userId ? String(userId) : null;
            }
        },
        {
            /**
   * 토큰 변경 리스너 등록
   */ key: "addTokenChangeListener",
            value: function addTokenChangeListener(listener) {
                this.listeners.push(listener);
            }
        },
        {
            /**
   * 토큰 변경 리스너 제거
   */ key: "removeTokenChangeListener",
            value: function removeTokenChangeListener(listener) {
                this.listeners = this.listeners.filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "notifyListeners",
            value: /**
   * 모든 리스너에게 토큰 변경 알림
   */ function notifyListeners(token) {
                this.listeners.forEach(function(listener) {
                    try {
                        listener(token);
                    } catch (error) {
                        console.error('[TokenManager] Error in token change listener:', error);
                    }
                });
            }
        },
        {
            /**
   * 토큰 클리어 (사용자 정보와 ID 토큰도 함께 삭제)
   */ key: "clearToken",
            value: function clearToken() {
                this.stopAutoRefresh();
                this.setToken(null);
                this.setRefreshToken(null);
                this.currentExpiresAt = null;
                localStorage.removeItem(this.storageKeys.tokenExpiresAtKey);
                // 중요: 토큰 클리어 시 사용자 정보와 ID 토큰도 함께 삭제
                // 이렇게 하지 않으면 auth_user는 남아있는데 auth_token은 없는 불일치 상태가 발생
                localStorage.removeItem(this.storageKeys.userKey);
                localStorage.removeItem(this.storageKeys.idTokenKey);
                console.log('[TokenManager] 토큰, 사용자 정보, ID 토큰 모두 클리어됨');
            }
        },
        {
            /**
   * Auth Server URL 설정
   */ key: "setAuthServerUrl",
            value: function setAuthServerUrl(url) {
                this.authServerUrl = url;
            }
        },
        {
            /**
   * 주기적 토큰 갱신 시작 (5분마다 토큰 상태 확인 및 갱신)
   */ key: "startAutoRefresh",
            value: function startAutoRefresh() {
                var intervalMinutes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
                if (this.refreshTimer) {
                    clearInterval(this.refreshTimer);
                }
                if (!this.currentRefreshToken) {
                    console.warn('[TokenManager] Refresh token not available. Cannot start auto refresh.');
                    return;
                }
                console.log("[TokenManager] Starting auto refresh every ".concat(intervalMinutes, " minutes"));
                var _this = this;
                this.refreshTimer = setInterval(/*#__PURE__*/ _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.currentRefreshToken && !_this.isRefreshing)) return [
                                    3,
                                    2
                                ];
                                console.log('[TokenManager] Auto refresh triggered');
                                return [
                                    4,
                                    _this.refreshTokenIfNeeded()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }), intervalMinutes * 60 * 1000);
            }
        },
        {
            /**
   * 주기적 토큰 갱신 중지
   */ key: "stopAutoRefresh",
            value: function stopAutoRefresh() {
                if (this.refreshTimer) {
                    clearInterval(this.refreshTimer);
                    this.refreshTimer = null;
                    console.log('[TokenManager] Auto refresh stopped');
                }
            }
        },
        {
            /**
   * 토큰 상태 디버깅 정보 출력 (브라우저 콘솔용)
   */ key: "debugTokenStatus",
            value: function debugTokenStatus() {
                var now = Date.now();
                var accessToken = this.getToken();
                var refreshToken = this.getRefreshToken();
                var expiresAt = this.currentExpiresAt;
                console.group('🔐 [TokenManager] Debug Status');
                console.log('현재 시간:', new Date().toISOString());
                console.log('Access Token 존재:', !!accessToken, accessToken ? "(길이: ".concat(accessToken.length, ")") : '');
                console.log('Refresh Token 존재:', !!refreshToken, refreshToken ? "(길이: ".concat(refreshToken.length, ")") : '');
                console.log('Token Type:', this.getTokenType());
                if (expiresAt) {
                    var timeUntilExpiry = expiresAt - now;
                    var minutesUntilExpiry = Math.floor(timeUntilExpiry / 1000 / 60);
                    console.log('만료 시간:', new Date(expiresAt).toISOString());
                    console.log('만료까지 남은 시간:', minutesUntilExpiry, '분');
                    console.log('만료 상태:', this.isTokenExpired() ? '만료됨' : '유효함');
                } else {
                    console.log('만료 시간 정보 없음');
                }
                console.log('자동 갱신 활성:', !!this.refreshTimer);
                console.log('현재 갱신 중:', this.isRefreshing);
                console.groupEnd();
            }
        },
        {
            key: "refreshTokenIfNeeded",
            value: /**
   * 필요 시 토큰 갱신 (수동 호출용)
   */ function refreshTokenIfNeeded() {
                var _this = this;
                return _async_to_generator(function() {
                    var refreshPromise, success;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.currentRefreshToken) {
                                    console.warn('[TokenManager] No refresh token available');
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                if (_this.isRefreshing && _this.pendingRefreshPromise) {
                                    console.log('[TokenManager] Refresh already in progress, waiting...');
                                    return [
                                        2,
                                        _this.pendingRefreshPromise
                                    ];
                                }
                                _this.isRefreshing = true;
                                refreshPromise = _async_to_generator(function() {
                                    var result, error;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                console.log('[TokenManager] Attempting token refresh...');
                                                return [
                                                    4,
                                                    handleRefreshTokenFlow(_this.currentRefreshToken, _this.authServerUrl, localStorage.getItem(_this.storageKeys.tokenTypeKey) || 'Bearer')
                                                ];
                                            case 1:
                                                result = _state.sent();
                                                if (result.success && result.accessToken) {
                                                    console.log('[TokenManager] Token refresh successful');
                                                    // 새 토큰으로 업데이트
                                                    _this.setToken(result.accessToken, result.tokenType || 'Bearer');
                                                    // 새 refresh token이 있다면 업데이트
                                                    if (result.refreshToken) {
                                                        _this.setRefreshToken(result.refreshToken);
                                                    }
                                                    return [
                                                        2,
                                                        true
                                                    ];
                                                } else {
                                                    console.error('[TokenManager] Token refresh failed:', result.error);
                                                    // refresh token이 만료된 경우 로그아웃 처리
                                                    if (result.error === 'invalid_grant') {
                                                        console.log('[TokenManager] Refresh token expired, clearing tokens');
                                                        _this.clearToken();
                                                    }
                                                    return [
                                                        2,
                                                        false
                                                    ];
                                                }
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 2:
                                                error = _state.sent();
                                                console.error('[TokenManager] Token refresh error:', error);
                                                return [
                                                    2,
                                                    false
                                                ];
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                                _this.pendingRefreshPromise = refreshPromise;
                                return [
                                    4,
                                    refreshPromise
                                ];
                            case 1:
                                success = _state.sent();
                                _this.isRefreshing = false;
                                _this.pendingRefreshPromise = null;
                                return [
                                    2,
                                    success
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (!TokenManager.instance) {
                    TokenManager.instance = new TokenManager();
                }
                return TokenManager.instance;
            }
        }
    ]);
    return TokenManager;
}();
_define_property(TokenManager, "instance", void 0);
// 싱글톤 인스턴스 export
export var tokenManager = TokenManager.getInstance();
